import {
  createScript,
  resolveUrl,
} from '@/features/game-window-integration/helpers/fusion/helpers';

export const loadFusionScript = (region: string): Promise<void> => {
  if (window.fusion) return Promise.resolve();

  return new Promise<void>((resolve, reject) => {
    const existing = document.getElementById(
      'fusion-lib',
    ) as HTMLScriptElement | null;

    if (existing) {
      if (window.fusion) {
        resolve();
      } else {
        reject(new Error('Fusion script tag exists but fusion not ready'));
      }
      return;
    }

    const fusionUrl = resolveUrl(region);

    if (!fusionUrl) {
      reject(new Error(`Missing Fusion config on region: ${region}`));
      return;
    }
    const script = createScript(fusionUrl);

    script.onload = () => {
      if (window.fusion) {
        resolve();
      } else {
        reject(new Error('Fusion script loaded but window.fusion missing'));
      }
    };
    script.onerror = () =>
      reject(new Error(`Failed to load Fusion script: ${fusionUrl}`));
    document.head.appendChild(script);
  });
};
